module.exports = __webpack_public_path__ + "static/media/dayDateHighlightDate.fa72046f.svg";